(function () {
  const players = document.querySelectorAll('.baseball-golf-bundles-video__frame');
  if (!players.length) return;

  players.forEach((frame) => {
    const video = frame.querySelector('.baseball-golf-bundles-video__player');
    const overlay = frame.querySelector('[data-video-overlay]');
    const playBtn = frame.querySelector('[data-video-play]');
    if (!video || !overlay || !playBtn) return;

    const startPlayback = () => {
      overlay.classList.add('is-hidden');
      video.setAttribute('controls', '');
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    playBtn.addEventListener('click', startPlayback);

    video.addEventListener('ended', () => {
      overlay.classList.remove('is-hidden');
      video.removeAttribute('controls');
      video.currentTime = 0;
    });
  });
})();
